module.exports = __webpack_public_path__ + "static/media/item_32_5.8fb3611a.png";